import { useMemo } from 'react';
import * as uuid from 'uuid';

export const useNewUuid = (): string => {
    return useMemo(() => uuid.v4(), []);
};

export const useFallbackToNewUuid = (uuidToCheck: string | null): string => {
    const newId = useNewUuid();
    return uuidToCheck ?? newId;
};
